import { render, staticRenderFns } from "./ProductFeed.vue?vue&type=template&id=74447880&scoped=true"
import script from "./ProductFeed.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductFeed.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductFeed.vue?vue&type=style&index=0&id=74447880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74447880",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatorShopProductFeedItem: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/product-feed/ProductFeedItem.vue').default,CSkeletonLoader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSkeletonLoader/CSkeletonLoader.vue').default,LoadingSpinner: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/LoadingSpinner.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CRow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CRow.vue').default,LtkListNoData: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkListNoData.vue').default})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
import Resize from 'vuetify/lib/directives/resize'
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Intersect,Resize,Scroll})
